import { gql } from 'Utils/apolloClient'

const stripePaymentIntentCreateMutation = gql`
  mutation stripePaymentIntentCreate($params: StripePaymentIntentCreateInput!) {
    stripePaymentIntentCreate(input: $params) {
      paymentIntent {
        clientSecret
        id
      }
    }
  }`

export default stripePaymentIntentCreateMutation
